export default __webpack_public_path__ + "static/media/Link.4b97733f.png";